const giftBagOrder = resolve => require(['@/pages/giftBag/index.vue'], resolve);
const giftBagReceive = resolve => require(['@/pages/giftBag/receive.vue'], resolve);

export default [
  /********************美礼卡管理*****************/
  //美礼卡发行
  {
    path: "/giftBagOrder",
    name: "礼包订单管理",
    component: giftBagOrder,
    meta: {
        keepAlive: true
    }
  },
  /*美礼卡发行下路由开始*/
  {
    path: "/giftBag/receive",
    name: "领取详情",
    component: giftBagReceive
  },
  
]
